export const Filters = ({ filterText, onFilter }) => (
  <div className="items-toolbar__search-group">
    <div className="input-icon items-toolbar__search-input">
      <input
        id="search"
        type="text"
        placeholder="Pesquisar"
        className="form-control"
        value={filterText}
        onChange={onFilter}
      />
      <span>
        <i className="flaticon2-search-1"></i>
      </span>
    </div>
  </div>
);
